import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from './storage.service';

export const authGuard: CanActivateFn = () => {
  const storage = inject(StorageService);
  const router = inject(Router);

  const isLoggedIn = storage.get('loginInfo') === 'true';
  const token = storage.get('token');
  const user = storage.getParsed<any>('user');

  if (isLoggedIn && token && (user?.user_id || user?.id || user?.email || user)) {
    try {
      const parts = token.split('.');
      if (parts.length === 3) {
        // Decode base64 URL payload safely handling padding & UTF-8
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        const payload = JSON.parse(jsonPayload);
        if (payload && typeof payload.exp === 'number') {
          const isExpired = Date.now() >= payload.exp * 1000;
          if (isExpired) {
            // JWT token has expired on client side - clear credentials and deny route
            storage.remove('token');
            storage.remove('user');
            storage.set('loginInfo', 'false');
            return router.createUrlTree(['/']);
          }
        }
      }
    } catch (e) {
      // Non-JWT or custom token payload - allow access if token exists
    }
    return true;
  }

  return router.createUrlTree(['/']);
};
